import { useQuery } from '@apollo/client';
import { GetCustomDatasourceByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import type { FC } from 'react';

type Props = {
  customDatasourceId: string | undefined;
};

const Breadcrumb: FC<Props> = ({ customDatasourceId }) => {
  const { data } = useQuery(GetCustomDatasourceByIdDocument, {
    variables: {
      Id: customDatasourceId!,
    },
    skip: !customDatasourceId,
  });

  return <>{data?.custom_datasource_by_pk?.Title ?? ''}</>;
};

export default Breadcrumb;
